<script setup>
import { computed, nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Dialog from 'next/dialog/Dialog.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const dashboard = ref({});
const dialogRef = ref(null);
const isOpen = ref(false);
const uiFlags = useMapGetter('wgptCustomDashboards/getUIFlags');

const description = computed(() =>
  t('WGPT_CUSTOM_DASHBOARDS.DELETE.CONFIRM_MESSAGE', {
    dashboardName: dashboard.value.name,
  })
);

const open = targetDashboard => {
  dashboard.value = targetDashboard;
  isOpen.value = true;
  nextTick(() => dialogRef.value?.open());
};

const close = () => {
  dialogRef.value?.close();
  isOpen.value = false;
  emit('close');
};

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptCustomDashboards/delete', dashboard.value.id);
    useAlert(t('WGPT_CUSTOM_DASHBOARDS.DELETE.SUCCESS'));
    close();
  } catch (error) {
    useAlert(error?.message || t('WGPT_CUSTOM_DASHBOARDS.DELETE.ERROR'));
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_CUSTOM_DASHBOARDS.DELETE.CONFIRM_TITLE')"
    :description="description"
    :confirm-button-label="t('WGPT_CUSTOM_DASHBOARDS.DELETE.CONFIRM_YES')"
    :cancel-button-label="t('WGPT_CUSTOM_DASHBOARDS.DELETE.CONFIRM_NO')"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
